export default __webpack_public_path__ + "static/media/gallery_05.c20b72e3.jpg";